import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Navbar from '../../components/Navbar';
import { useRouter } from 'next/router';
import BlogPostPage from '../../components/Blog/post-page';
import Footer from '../../components/Blog/footer';
import { HeadSeo } from '../../components/Seo';
import { Fallback } from '../../components/Blog/fallback';
import Link from 'next/link';
import { ArrowLeftIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next';

var Slug = function Slug(_ref) {
  var _posts$, _posts$2, _posts$3;

  var posts = _ref.posts;
  var router = useRouter();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (router.isFallback) {
    return /*#__PURE__*/_jsx(Fallback, {});
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeadSeo, {
      siteName: 'Yalendar.com',
      title: "".concat((_posts$ = posts[0]) === null || _posts$ === void 0 ? void 0 : _posts$.title),
      url: "https://yalendar.com/blog/".concat((_posts$2 = posts[0]) === null || _posts$2 === void 0 ? void 0 : _posts$2.slug),
      description: "".concat((_posts$3 = posts[0]) === null || _posts$3 === void 0 ? void 0 : _posts$3.title)
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative pt-6 pb-16 sm:pb-24",
      children: [/*#__PURE__*/_jsx(Navbar, {
        appURL: 'https://app.yalendar.com',
        hideNavigation: true,
        isVisible: true
      }), posts && /*#__PURE__*/_jsxs("section", {
        className: "px-4 mx-auto mt-16 max-w-7xl sm:mt-24",
        children: [/*#__PURE__*/_jsx(Link, {
          href: "/blog",
          children: /*#__PURE__*/_jsxs("a", {
            className: "flex items-center justify-center px-4 py-2 my-4 text-gray-700 border border-gray-500 rounded-md cursor-pointer w-36",
            children: [/*#__PURE__*/_jsx(ArrowLeftIcon, {
              className: "w-6 h-6"
            }), /*#__PURE__*/_jsx("span", {
              className: "ml-4 text-base font-semibold",
              children: t('blog.backToAllPosts')
            })]
          })
        }), /*#__PURE__*/_jsx(BlogPostPage, {
          post: posts[0]
        }), /*#__PURE__*/_jsx("div", {
          className: "",
          children: /*#__PURE__*/_jsx(Footer, {})
        })]
      })]
    })]
  });
};

export var __N_SSG = true;
export default Slug;